import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

export const StyledPaper = styled(Paper, {
  shouldForwardProp: prop => prop !== 'isLoading'
})(({ theme, isLoading }) => ({
  padding: theme.spacing(),
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(4)
  },
  opacity: isLoading ? 0 : 1
}));

export const ButtonCnt = styled('div', {
  shouldForwardProp: prop => !['hasBorderTop', 'isLoading'].includes(prop)
})(({ theme, hasBorderTop, isLoading }) => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: '#EEE',
  zIndex: theme.zIndex.appBar,
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  opacity: isLoading ? 0 : 1,
  ...(hasBorderTop && {
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    boxShadow: 'rgba(0, 0, 0, 0.45) 0px -17px 20px -22px'
  })
}));

export const ErrorCtn = styled('div')(({ theme }) => ({
  position: 'sticky',
  bottom: 69,
  paddingLeft: 14,
  marginTop: 8,
  color: '#fff',
  borderRadius: 2,
  background: 'red',
  zIndex: theme.zIndex.appBar
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));

export const FormWrapper = styled('form', {
  shouldForwardProp: prop => prop !== 'isLoading'
})(({ isLoading }) => ({
  ...(isLoading && {
    position: 'relative',
    height: '100%'
  })
}));

export const PreloaderCtn = styled('div')({
  position: 'absolute',
  width: '100%',
  height: 'calc(100% - 76px)',
  zIndex: 3,
  '& svg': {
    top: '0 !important',
    left: '0 !important',
    right: 0,
    bottom: 0,
    margin: 'auto',
    transform: 'none !important'
  }
});
